import React from "react";
import { Box, Typography, Button, Avatar, IconButton, CardContent } from "@mui/material";
import { Edit as EditIcon, Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import EditExperienceModal from "../../modals/EditExperienceModal";

const PreviousWorkSection = ({
  experiences,
  isEditModePersonalInformation,
  errors,
  isAnyButtonInEditMode,
  handleAddExperience,
  handleEditExperience,
  handleDeleteExperience,
  isModalOpen,
  setIsModalOpen,
  selectedExperience,
  setSelectedExperience,
  handleSaveExperience,
  formatDate,
}) => {
  return (
    <CardContent sx={{ mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Previous Work</Typography>
        <Button
          startIcon={<EditIcon />}
          size="small"
          sx={{
            borderRadius: 2,
            border: "1px solid #D3D3D3",
            backgroundColor: "transparent",
            color:
              isEditModePersonalInformation && Object.keys(errors).length === 0
                ? "#1E40AF"
                : "grey",
            "&:hover": {
              borderColor: "#1E40AF",
              color: "#1E40AF",
            },
          }}
          onClick={handleAddExperience}
          disabled={isAnyButtonInEditMode || Object.keys(errors).length > 0}
        >
          Add Experience
        </Button>
      </Box>

      <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ mb: 4 }}>
        List your past employers or experiences
      </Typography>

      <Box
        sx={{
          border: "2px dashed",
          borderColor: "divider",
          borderRadius: 4,
          p: 3,
          m: -2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        {experiences &&
          experiences.map((exp, index) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
              }}
              key={index}
            >
              <Avatar
                sx={{
                  bgcolor: "grey.200",
                  color: "text.primary",
                  mr: 2,
                }}
              >
                {exp.organization.charAt(0).toUpperCase()}
              </Avatar>
              <Box>
                <Typography variant="body1">{exp.job_title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {exp.organization}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {formatDate(exp.starting)} - {exp.end ? ` ${formatDate(exp.end)}` : "Present"}
                </Typography>
              </Box>

              <IconButton
                onClick={() => handleEditExperience(exp)}
                sx={{ ml: 2 }}
                disabled={isAnyButtonInEditMode || Object.keys(errors).length > 0}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                onClick={() => handleDeleteExperience(exp)}
                sx={{ ml: 2 }}
                disabled={isAnyButtonInEditMode || Object.keys(errors).length > 0}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAddExperience}
          disabled={isAnyButtonInEditMode || Object.keys(errors).length > 0}
          sx={{
            mt: 2,
            borderRadius: 8,
            borderColor: "primary.main",
            color: "primary.main",
          }}
        >
          Add experience
        </Button>
      </Box>

      <EditExperienceModal
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedExperience(null);
        }}
        onSave={handleSaveExperience}
        experience={selectedExperience}
      />
    </CardContent>
  );
};

export default PreviousWorkSection;
